import React from "react";
import { ChatBoxListUIControllerContext } from "../ChatBoxListContext";

export const useChatBoxListUIController = () => {
	return React.useContext(ChatBoxListUIControllerContext);
};
